import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import LoginView from '@/components/Login'
import DashView from '@/components/Dash'
import DashboardView from '@/components/views/Dashboard'

import QuotationView from '@/components/views/quotations/index.vue'
import QuotationListView from '@/components/views/quotations/list.vue'
import QuotationShowView from '@/components/views/quotations/show.vue'
import QuotationAddView from '@/components/views/quotations/add.vue'

import InvoiceView from '@/components/views/invoices/index.vue'
import InvoiceListView from '@/components/views/invoices/list.vue'
import InvoiceShowView from '@/components/views/invoices/show.vue'
import InvoiceAddView from '@/components/views/invoices/add.vue'

import CustomerView from '@/components/views/customers/index.vue'

import ReceiptView from '@/components/views/receipts/index.vue'
import ReceiptListView from '@/components/views/receipts/list.vue'
import ReceiptShowView from '@/components/views/receipts/show.vue'
import ReceiptAddView from '@/components/views/receipts/add.vue'

import CashBillView from '@/components/views/cashBills/index.vue'
import CashBillListView from '@/components/views/cashBills/list'
import CashBillShowView from '@/components/views/cashBills/show'
import CashBillAddView from '@/components/views/cashBills/add'

import ReportView from '@/components/views/reports/index.vue'

import OfficerView from '@/components/views/officer'
import GangView from '@/components/views/gang'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/logout',
      redirect: to => {
        if (this.$auth) {
          this.$auth.logout()
        }
        store.dispatch('logout')
        return '/'
      }
    },
    {
      path: '/login',
      component: LoginView,
      meta: { auth: false, description: 'Login' }
    },
    {
      path: '/',
      component: DashView,
      meta: { auth: false },
      children: [
        {
          path: 'dashboard',
          alias: '',
          component: DashboardView,
          name: 'Dashboard',
          meta: { auth: true, description: 'หน้าหลัก' }
        }, {
          path: 'customers',
          component: CustomerView,
          meta: { description: 'Customer', auth: true }
        }, {
          path: 'quotations',
          component: QuotationView,
          meta: { description: 'Quotation', auth: true },
          children: [
            {
              path: 'list',
              alias: '',
              component: QuotationListView,
              name: 'QuotationList',
              meta: { description: 'Quotation', auth: true }
            }, {
              path: 'add',
              component: QuotationAddView,
              name: 'QuotationAdd',
              meta: { description: ' Quotation', auth: true }
            }, {
              path: ':id',
              component: QuotationShowView,
              name: 'QuotationShow',
              props: true,
              meta: { description: ' Quotation', auth: true }
            }
          ]
        }, {
          path: 'invoices',
          component: InvoiceView,
          meta: { description: 'Invoice', auth: true },
          children: [
            {
              path: 'list',
              alias: '',
              component: InvoiceListView,
              name: 'InvoiceList',
              meta: { description: 'Invoice', auth: true }
            }, {
              path: 'add/quotation/:quotationId',
              component: InvoiceAddView,
              props: true,
              meta: { description: 'Invoice', auth: true }
            }, {
              path: 'add',
              component: InvoiceAddView,
              name: 'InvoiceAdd',
              meta: { description: ' Invoice', auth: true }
            }, {
              path: ':id',
              component: InvoiceShowView,
              name: 'InvoiceShow',
              props: true,
              meta: { description: ' Invoice', auth: true }
            }
          ]
        }, {
          path: 'receipts',
          component: ReceiptView,
          meta: { description: 'Receipt', auth: true },
          children: [
            {
              path: 'list',
              alias: '',
              component: ReceiptListView,
              name: 'ReceiptList',
              meta: { description: 'Receipt', auth: true }
            }, {
              path: 'add/invoice/:invoiceId',
              component: ReceiptAddView,
              props: true,
              meta: { description: 'Receipt', auth: true }
            }, {
              path: 'add',
              component: ReceiptAddView,
              name: 'ReceiptAdd',
              meta: { description: ' Receipt', auth: true }
            }, {
              path: ':id',
              component: ReceiptShowView,
              name: 'ReceiptShow',
              props: true,
              meta: { description: ' Receipt', auth: true }
            }
          ]
        }, {
          path: 'cashBills',
          component: CashBillView,
          meta: { description: 'CashBill', auth: true },
          children: [
            {
              path: 'list',
              alias: '',
              component: CashBillListView,
              name: 'CashBillList',
              meta: { description: 'CashBill', auth: true }
            }, {
              path: 'add',
              component: CashBillAddView,
              name: 'CashBillAdd',
              meta: { description: ' CashBill', auth: true }
            }, {
              path: ':id',
              component: CashBillShowView,
              name: 'CashBillShow',
              props: true,
              meta: { description: ' CashBill', auth: true }
            }
          ]
        }, {
          path: 'officers',
          component: OfficerView,
          meta: { description: 'Officer', auth: true }
        }, {
          path: 'gangs',
          component: GangView,
          meta: { description: 'Gang', auth: true }
        }, {
          path: 'reports',
          component: ReportView,
          meta: { description: 'Report', auth: true }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js